import { render } from "./DirectSponsoredHistory.vue?vue&type=template&id=1ecdd5eb"
import script from "./DirectSponsoredHistory.vue?vue&type=script&lang=ts"
export * from "./DirectSponsoredHistory.vue?vue&type=script&lang=ts"
script.render = render

export default script